import React, { Component } from "react";

import { CCol, CRow, CTextarea, CLabel, CBadge } from "@coreui/react";
import { connect } from "react-redux";
import { InputGroup, Input, FormGroup } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import Loading from "../Loading";
import Literarte from "../SlateComponents/Literarte";

import "../../scss/style2.scss";

class CorrectLiterarte extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      comment: "",
      criterions: [],
      value: [
        {
          type: "paragraph",
          children: [{ text: "" }]
        }
      ],
      pages: [],
      currentPage: 0,
      note: "-"
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let pages = [];

    if (this.props.production) {
      for (let i = 0; i < this.props.production.pages.length; i++) {
        pages.push(JSON.parse(this.props.production.pages[i].content));
      }

      this.setState({
        // production_id: this.props.production.id,
        criterions: this.props.production.criterion.map(item => ({
          ...item,
          note: item.note || 0,
          comments: item.comments || "",
          noteValueStatus: 1
        })),
        pages,
        loading: false,
        value: pages[0],
        note: this.props.production.value,
        comment: this.props.production.comments || ""
      });
    }
  }

  changePage = index => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      value: this.state.pages[index],
      currentPage: index
    });
  };

  prevPage() {
    const index = Math.max(this.state.currentPage - 1, 0);
    this.setState(state => ({
      value: state.pages[index],
      currentPage: index
    }));
  }

  nextPage() {
    const index = Math.min(
      this.state.currentPage + 1,
      this.state.pages.length - 1
    );
    this.setState(state => ({
      value: state.pages[index],
      currentPage: index
    }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div
          className="p-3 d-flex align-items-center justify-content-center"
          style={{ overflow: "auto" }}
        >
          <Loading />
        </div>
      );
    }

    return (
      <div className="p-0 d-flex w-100" style={{ overflow: "auto" }}>
        <div
          style={{
            height: "100%",
            backgroundColor: "#f6f8f9",
            width: "30rem"
          }}
          className="p-3 overflow-auto d-flex flex-column"
        >
          <FormGroup className="mb3">
            <CLabel>Comentários</CLabel>
            <InputGroup>
              <CTextarea
                rows={6}
                value={this.state.comment}
                placeholder="(Nenhum comentário)"
                className="bg-transparent"
                disabled
              />
            </InputGroup>
          </FormGroup>
          {this.state.criterions.map((criterion, index) => (
            <React.Fragment key={criterion.id}>
              <FormGroup className="mb3">
                <CLabel>{`${criterion.name} (${criterion.value})`}</CLabel>
                <CRow>
                  <CCol lg="3">
                    <InputGroup>
                      <Input
                        type="number"
                        value={criterion.note}
                        disabled
                        className="bg-transparent"
                      />
                    </InputGroup>
                  </CCol>
                  <CCol lg="9">
                    <InputGroup>
                      <Input
                        type="text"
                        value={criterion.comments}
                        disabled
                        placeholder="(Nenhum comentário)"
                        className="bg-transparent"
                      />
                    </InputGroup>
                  </CCol>
                </CRow>
              </FormGroup>
            </React.Fragment>
          ))}
          <FormGroup className="mt-4 text-center">
            <CLabel className="font-weight-bold">Nota final</CLabel>
            <h1 className="font-weight-bold m-0">{this.state.note || "-"}</h1>
          </FormGroup>
        </div>
        <div
          style={{
            height: "100%",
            backgroundColor: "#ffffff",
            flex: 1,
            boxShadow:
              "-3px 0px 6px -3px rgba(60, 64, 67, 0.15), 3px 0px 6px -3px rgba(60, 64, 67, 0.15)",
            position: "relative"
          }}
          className="overflow-auto"
        >
          <CBadge
            color="dark"
            className="p-3 position-absolute d-flex align-items-center"
            style={{ top: "1rem", right: "1rem" }}
          >
            <i
              className="fa fa-chevron-left cursor"
              onClick={() => this.prevPage()}
            ></i>
            <div
              className="mx-3"
              style={{ fontSize: "14px", marginBottom: "1px" }}
            >
              {this.state.currentPage + 1}/{this.state.pages.length}
            </div>
            <i
              className="fa fa-chevron-right cursor"
              onClick={() => this.nextPage()}
            ></i>
          </CBadge>
          <Literarte value={this.state.value} edit={false} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CorrectLiterarte);
